<template>
  <form ref="form" class="mc-form" @submit.prevent="submitImei">
    <b-row>
      <b-col md="12">
        <!-- IMEI -->
        <div class="mb-3 mc-input-info">
          <label class="mt-3 required">IMEI</label>
          <b-form-input id="imei" placeholder="Masukkan IMEI yang akan didaftarkan" v-model="form.imei" type="number"
            :class="{ 'is-invalid': $v.form.imei.$error }" trim @input="onImeiChange"
            @keydown="portKeydown($event, (preventZeroFirst = true), (preventComma = true))"
            :disabled="disabledRCD || !hasAccessAll" />

          <div v-if="$v.form.imei.$error" class="invalid-feedback">
            <span v-if="!$v.form.imei.required"> IMEI Wajib Terisi </span>
          </div>
        </div>

        <!-- SIMCARD -->
        <div class="mb-3 mc-input-info">
          <b-form-group label="Nomor SIMCard" label-class="required">
            <b-form-input id="phoneNo" placeholder="Nomor SIMCard" type="number" v-model="form.phoneNo" trim
              :class="{ 'is-invalid': $v.form.phoneNo.$error }"
              @keydown="portKeydown($event, (preventZeroFirst = true))" :disabled="disabledRCD" />

            <div v-if="$v.form.phoneNo.$error" class="invalid-feedback">
              <span v-if="!$v.form.phoneNo.required">
                {{ $t('setting.form.simcard') }} Wajib Terisi
              </span>
              <span v-else-if="!$v.form.phoneNo.isIndonesianPhoneNumber">
                {{ $t('qcdevice.incomming.invalidPhoneNumber') }}
              </span>
            </div>
          </b-form-group>
        </div>

        <!-- Device Type -->
        <div class="mb-2">
          <label class="required">Tipe Perangkat</label>

          <!-- Input fake -->
          <b-form-input v-if="!showDeviceType" id="deviceType"
            :value="form.deviceTypes?.device_name ?? form.deviceTypes?.deviceName" trim @click="showDeviceTypes"
            :disabled="disabledRCD" />

          <!-- Multiselect -->
          <multiselect v-else id="deviceTypeSelect" ref="deviceTypeRef" v-model="form.deviceTypes"
            @input="(val) => { form.deviceTypes = val }" :options="deviceTypeOptions" label="deviceName"
            placeholder="Tipe Perangkat" :class="{ 'is-invalid': $v.form.deviceTypes.$error }" :allow-empty="false"
            open-direction="top" :custom-label="customLabelDevice" :disabled="disabledRCD" />

          <div v-if="$v.form.deviceTypes.$error" class="invalid-feedback">
            <span v-if="!$v.form.deviceTypes.required">
              {{ $t('setting.form.deviceType') }} Wajib Terisi
            </span>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- BUTTON -->
    <b-button variant="primary" v-if="!isEdit" @click="submitImei" :disabled="disabledRCD">
      Daftarkan IMEI
    </b-button>

    <b-button variant="primary" v-if="isEdit" :disabled="disabledRCD" @click="submitImei">
      {{ $t('global.saveChanges') }}
    </b-button>

    <b-row class="modal-body"><b-col md="12"></b-col></b-row>

    <!-- RESULT COLLAPSE -->
    <b-collapse id="accordion-3" v-model="accordionVisible" accordion="my-accordion" role="tabpanel">
      <b-card no-body>
        <template #header>
          <h4 class="mb-0">{{ responseModal.title }}</h4>
        </template>

        <b-list-group flush>
          <b-list-group-item>IMEI : {{ responseModal.imei }}</b-list-group-item>
          <b-list-group-item>Vehicle ID : {{ responseModal.vehicleId }}</b-list-group-item>
          <b-list-group-item style="color: #07a76d; font-weight: bold">
            Status : {{ responseModal.status }}
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-collapse>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect'
import * as erpApi from '@/services/rest-api-sms/lib/erp/imei-check-erp'
import { required } from 'vuelidate/lib/validators'
import { isIndonesianPhoneNumber } from '@/helpers/validators'
import { Helper } from '@/mixin/helper'

export default {
  components: { Multiselect },

  props: {
    form: Object,
    isEdit: Boolean,
    accordionVisible: Boolean,
    responseModal: Object,
    hasAccessAll: Boolean,
    disabledRCD: Boolean,
    deviceTypeOptions: {   // ✅ GUNAKAN INI
      type: Array,
      default: () => []
    }
  },

  mixins: [Helper],

  data() {
    return {
      showDeviceType: true,
      isLoading: false,
      debounceTimer: null,
    }
  },

  validations: {
    form: {
      imei: { required },
      phoneNo: { required, isIndonesianPhoneNumber },
      deviceTypes: { required },
    },
  },

  // ❌ HAPUS async created(), tidak perlu load lagi

  methods: {
    submitImei(bvModalEvent) {
      if (bvModalEvent) bvModalEvent.preventDefault()
      this.$v.form.$touch()

      if (this.$v.form.$error) {
        console.log('Mohon isi semua field yang diperlukan')
        return
      }

      if (this.isEdit) {
        this.$emit('update-device', this.form)
      } else {
        this.$emit('submit-imei', this.form)
      }
    },

    async onImeiChange(e) {
      console.log('🔵 onImeiChange triggered, IMEI:', e)
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(async () => {
        try {
          const IMEIFromERP = await this.checkIMEIinERP(e)
          console.log('🟢 ERP result:', IMEIFromERP)
          
          if (IMEIFromERP?.device_code) {
            // ✅ GUNAKAN deviceTypeOptions dari prop (sudah ready)
            const deviceFound = this.deviceTypeOptions.find(
              (item) => item.deviceCode == IMEIFromERP.device_code
            )
            console.log('🟡 Device found:', deviceFound)
            
            if (deviceFound) {
              this.form.deviceTypes = deviceFound
              console.log('🟢 Set deviceTypes:', this.form.deviceTypes)
              this.$emit('device-auto-selected', deviceFound)
            }
          }
        } catch (error) {
          console.error('🔴 Error:', error)
        }
      }, 300)
    },

    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },

    showDeviceTypes() {
      this.showDeviceType = false
      this.$nextTick(() => {
        this.showDeviceType = true
      })
    },

    async checkIMEIinERP(imei) {
      const params = { imei: imei }
      const res = await erpApi.getImeiCheckErp(params)
      console.log("res", res)
      return res?.data
    },
  },
}
</script>
